/* eslint-disable max-len */

import React from 'react';

const ArrowTop = () => (
  <svg width="154" height="41" viewBox="0 0 154 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path className="arrow-top-bg" d="M77.9528 0C42.7664 0 53.0047 40.9851 0.0921631 40.9851H153.908C104.072 40.9851 113.139 0 77.9528 0Z" fill="#FFE600" />
    <path className="arrow-top-icon" d="M72.8978 25.9923L78.9016 19.9885L84.9116 25.9985L85.9722 24.9379L78.9016 17.8672L71.8372 24.9316L72.8978 25.9923Z" fill="black" fillOpacity="0.9" />
  </svg>
);

export default ArrowTop;
